<div class="header-container">
  <div class="header-left">
    <app-search-box 
      [debounce]="true" 
      (search)="search($event)"
    />
    <mat-checkbox 
      (change)="showArchivedClicked($event)" 
      [disableRipple]="true" 
      class="ml-3"
    >
      Show Archived
    </mat-checkbox>
  </div>
  <div class="sign-wrapper">
    <span *ngIf="selectionsCount > 0" class="sign-count">
      {{ selectionsCount }} {{ selectionsCount === 1 ? 'item' : 'items' }} selected
    </span>
    <thera-button 
      *ngIf="true" 
      matTooltip="Only associated discipline allowed." 
      class="mr-2" 
      [config]="signBtnConfig"
      [disabled]="!enableSign" 
      (click)="SignClicked()" 
    />
  </div>
</div>